import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import img from "./modern-female-device-2.jpg"

export default function HeroSection() {
  const [isHovered, setIsHovered] = useState(false);
  const contentSectionRef = useRef(null);
  const dividerRef = useRef(null);
   const navigate = useNavigate();
  // Handle hover effect on button
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    setTimeout(() => {
        const contentElements = document.querySelectorAll(
            ".content-subgrid h1, .content-subgrid p, .content-subgrid button"
        );
        contentElements.forEach((el) => {
            el.style.opacity = 1;
            el.style.transform = "translateY(0px)";
        });

      
        if (dividerRef.current) {
            dividerRef.current.style.width = "100%";
        }

     
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const heroSection = document.querySelector(".hero-section");
            if (heroSection) {
                const heroSectionHeight = heroSection.offsetHeight;
                const paddingTop = parseFloat(getComputedStyle(heroSection).paddingTop);
                const paddingBottom = parseFloat(getComputedStyle(heroSection).paddingBottom);
                const parallaxSpeed = 0.2;

                const effectiveHeight = heroSectionHeight - paddingTop - paddingBottom;

                if (scrollPosition < effectiveHeight) {
                    let offset = scrollPosition * parallaxSpeed;
                    const maxOffset = effectiveHeight - paddingBottom;

                    if (offset > maxOffset) offset = maxOffset;

                    const opacity = 1 - scrollPosition / effectiveHeight;

                    if (contentSectionRef.current) {
                        contentSectionRef.current.style.transform = `translateY(${offset}px)`;
                        contentSectionRef.current.style.opacity = opacity > 0 ? opacity : 0;
                    }
                } else {
                    if (contentSectionRef.current) {
                        contentSectionRef.current.style.transform = "translateY(0px)";
                        contentSectionRef.current.style.opacity = 0;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, 1000);
}, []);

const [showScrollIndicator, setShowScrollIndicator] = useState(true);

// Hide scroll indicator after user scrolls
useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 10) {
      setShowScrollIndicator(false);
    } else {
      setShowScrollIndicator(true);
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  return (
    <section className="hero-section" id="section1">
      <section className="video-background">
      <div className="hero-img-section">
                <img src={img} alt="" role="presentation"/>
            </div>
        <div className="content-section" ref={contentSectionRef}>
          <div className="content-subgrid">
            <h1 className="text-balance">
              Transforming Payments Into Trusted Connections
            </h1>
            <button
              className={`paynow-btn ${isHovered ? "hovered" : ""}`}
              type="button"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={()=>navigate('/Pay')}
            >
              Make a Payment
            </button>
            <div
              className="divider"
              ref={dividerRef}
              style={{ width: "0%" }}
            ></div>
        <p className="text-balance"> We accept ACH transfers, as well as Visa, MasterCard, and Discover credit and debit cards. We also support payments through Google Pay and Apple Pay.</p>

          </div>
        </div>
        {/* {showScrollIndicator && (
  <div
    className="scroll-indicator"
    id="scrollIndicator"
    onClick={() => {
      window.scrollTo({
        top: window.innerHeight + 50,
        behavior: "smooth",
      });
    }}
  >
    <span className="arrow"><i className="bx bx-chevrons-down"></i></span>
  </div>
)} */}
      </section>
    </section>
  );
}
